import { render, staticRenderFns } from "./AnnualRuns.vue?vue&type=template&id=25572fc8"
import script from "./AnnualRuns.vue?vue&type=script&lang=js"
export * from "./AnnualRuns.vue?vue&type=script&lang=js"
import style0 from "./AnnualRuns.vue?vue&type=style&index=0&id=25572fc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports